import { useEffect } from 'react';
import { ErrorMessages } from '@/src/app/api/_utils/errorMessages';
import { DashboardErrorPage } from '@/src/app/_components/error-page/error-page';

export default function DefaultError({ error, reset, key }: { key?: string; error: Error; reset: () => void }) {
  console.debug(`${key} error`);

  useEffect(() => {
    // Log the error to an error reporting service
    if (error.message === ErrorMessages.NO_JWT) {
      window.location.replace('/api/auth/login');
    }
  }, [error]);

  return <DashboardErrorPage title={error.message} button={{ text: 'Try again', onClick: reset }} />;
}
